/**
 * Helper class for booking related functions used in customer portal
 */
import get from 'lodash.get';
import bookingProgress from '../constants/messages/bookingProgress';
import BOOKING_ROUTES from '../constants/enums/BookingRoutes';
import BookingPermission from '../constants/enums/BookingPermission';

export default class BookingHelpers {
  static calculateAverageNightlyRate(totalValue, numOfNights) {
    return numOfNights !== 0 ? totalValue / numOfNights : 0;
  }

  static getInitialOrEditFlowBooking(booking) {
    // eslint-disable-next-line
    if (sessionStorage.hasOwnProperty('bookingObject')) {
      return booking.getBookingObject()?.booking;
    }
    return booking.booking;
  }
}

/* eslint-disable */
function omitDeepArrayWalk(arr, key) {
  return arr.map(val => {
    if (Array.isArray(val)) return omitDeepArrayWalk(val, key);
    if (typeof val === 'object') return omitDeep(val, key);
    return val;
  });
}

// Remove any field you want in deeeply nested objects and arrays
export const omitDeep = (obj, key) => {
  const keys = obj && Object.keys(obj);
  const newObj = {};
  keys.forEach(i => {
    if (i !== key && obj) {
      const val = obj[i];
      if (val instanceof Date) newObj[i] = val;
      else if (Array.isArray(val)) newObj[i] = omitDeepArrayWalk(val, key);
      else if (typeof val === 'object' && val !== null) newObj[i] = omitDeep(val, key);
      else newObj[i] = val;
    }
  });
  return newObj;
};
/* eslint-enable */

export const bookingNavItems = props => {
  const { intl } = props;
  return [
    /*    {
      key: BOOKING_ROUTES.ASSIGNMENT,
      label: intl.formatMessage(bookingProgress.stepRoomAssignments),
      onClick: undefined
    }, */
    {
      key: BOOKING_ROUTES.ROOMSCHEDULE,
      label: intl.formatMessage(bookingProgress.stepRoomSchedules),
      onClick: undefined
    },
    {
      key: BOOKING_ROUTES.COST_TRACKING_CODES,
      label: intl.formatMessage(bookingProgress.stepCostTrackingCodes),
      onClick: undefined
    },
    {
      key: BOOKING_ROUTES.PAYMENT,
      label: intl.formatMessage(bookingProgress.stepPayment),
      onClick: undefined
    },
    {
      key: BOOKING_ROUTES.SUMMARY,
      label: intl.formatMessage(bookingProgress.stepSummary),
      onClick: undefined
    }
  ];
};

export const buildBookingFlowPolicies = bookingArgs => {
  const permissions = get(bookingArgs, 'permissions') || [];
  const base = {
    canAddGuest: permissions.includes(BookingPermission.ADD_GUEST),
    canRemoveGuest: permissions.includes(BookingPermission.REMOVE_GUEST),
    canEditGuestRoom: permissions.includes(BookingPermission.EDIT_GUEST_CHANGE_ROOM),
    canEditGuestInformation: permissions.includes(BookingPermission.EDIT_GUEST_INFORMATION),
    canEditRoomAssignments: permissions.includes(BookingPermission.EDIT_GUEST_INFORMATION),
    canSelectBookingDates: permissions.includes(BookingPermission.SELECT_BOOKING_DATES),
    canSetCrewSchedule: permissions.includes(BookingPermission.SET_CREW_SCHEDULE),
    canSetGuestSchedule: permissions.includes(BookingPermission.SET_GUEST_SCHEDULE),
    canSubmitPayment: permissions.includes(BookingPermission.SUBMIT_PAYMENT),
    canFinalizeBooking: permissions.includes(BookingPermission.FINALIZE_BOOKING),
    canCancelBooking: permissions.includes(BookingPermission.CANCEL_BOOKING),
    canSetAnyDate: permissions.includes(BookingPermission.ADMIN_NO_DATE_RESTRICTIONS)
  };
  return {
    ...base,
    canAccessRoomAssignments:
      base.canAddGuest ||
      base.canRemoveGuest ||
      base.canEditGuestRoom ||
      base.canEditGuestInformation ||
      base.canEditRoomAssignments,
    canAccessSchedule:
      base.canSubmitPayment && (base.canSelectBookingDates || base.canSetGuestSchedule || base.canSetCrewSchedule)
  };
};

export const roomSchedulesAnalyticsFunction = bookingArgs => {
  const {
    eventName,
    analytics,
    booking,
    sectionName = 'Booking Details',
    clickID = 'N/A',
    initialFlow = true,
    organizationSlug,
    router,
    guestCount = 'N/A',
    roomCount = 'N/A',
    bookingStartTime = 'N/A',
    bookingSubmissionTime = 'N/A',
    roomName = 'N/A',
    destinationUrl,
    language
  } = bookingArgs;
  const { bookingNumber } = booking;
  analytics.trackGA4('track-event', {
    eventName,
    bookingStartTime,
    bookingSubmissionTime,
    sectionName,
    guestCount,
    roomName,
    roomCount,
    bookingNumber,
    bookingFlow: initialFlow ? 'Initial' : 'Edit',
    clickID,
    destinationUrl: destinationUrl ? router.getRouteUrl(destinationUrl, { bookingNumber, organizationSlug }) : 'N/A',
    language
  });
};
